export const BrandMark = ({ className = "h-10 w-10" }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" aria-hidden="true">
    <rect width="64" height="64" rx="14" fill="#1D4ED8" />
    <path d="M17 54 L26 12 h5 L24 54 Z" fill="#FFFFFF" />
    <path d="M47 54 L38 12 h-5 L40 54 Z" fill="#FFFFFF" />
    <rect x="10" y="25" width="44" height="7" rx="1.5" fill="#FFFFFF" />
    <rect x="13" y="32" width="5" height="9" fill="#FFFFFF" />
    <rect x="46" y="32" width="5" height="9" fill="#FFFFFF" />
  </svg>
);

export const Logo = ({ inverted = false }) => (
  <span className="flex items-center gap-3" data-testid="brand-logo">
    <BrandMark />
    <span className="leading-none">
      <span className={`block font-display text-lg font-extrabold tracking-tight ${inverted ? "text-white" : "text-slate-900"}`}>
        SOLARIS <span className={inverted ? "text-blue-300" : "text-blue-700"}>TRANSPORT</span>
      </span>
      <span className={`mt-1 block text-[10px] font-semibold uppercase tracking-[0.35em] ${inverted ? "text-blue-200" : "text-slate-500"}`}>
        Ltd · Tadcaster
      </span>
    </span>
  </span>
);

export default Logo;
